import { useForm } from 'react-hook-form'
import { useAppSelector } from '@/hooks/store.ts'
import { appSlice } from '@/store/appSlice.ts'
import { cartSlice } from '@/store/cartSlice/index.ts'
import { getLocalPhonePrefix } from '@/utils/getLocalPhonePrefix.ts'

export const useUserDataForm = () => {
  const discountCode = useAppSelector(cartSlice.selectors.discountCode)

  return useForm<InsertDataFormType>({
    defaultValues: getDefaultValues(discountCode),
    mode: 'onBlur',
  })
}

function getDefaultValues(discountCode: string) {
  const userData = useAppSelector(appSlice.selectors.userData)
  const defaultName = userData.name
  const defaultSurname = userData.surname
  const defaultEmail = userData.email
  const defaultPhone = userData.phone

  return {
    dog: {
      breed: '',
      chipNumber: '',
      gender: 'male',
      name: '',
    },
    invoice: {
      address: '',
      businessName: '',
      certifiedEmail: '',
      city: '',
      country: '',
      fiscalCode: '',
      houseNumber: '',
      province: '',
      request: 'receipt',
      sdiCode: '',
      vatNumber: '',
      zipCode: '',
    },
    notes: '',
    promo: {
      discountCode,
      newsletter: false,
    },
    user: {
      email: defaultEmail ?? '',
      firstName: defaultName ?? '',
      fiscalCode: '',
      lastName: defaultSurname ?? '',
      phoneNumber: defaultPhone ?? '',
      phonePrefix: getLocalPhonePrefix(),
    },
  }
}

export type InsertDataFormType = ReturnType<typeof getDefaultValues>
